import { ISingleService } from "types";

export const sortServicesByIndex = (services: ISingleService[]): ISingleService[] =>
  [...services].sort((firstService, secondService) => firstService.index - secondService.index);
